module.exports = __webpack_public_path__ + "img/tiagoSofio.24b01947.webp";